import _ from "lodash";

import React from "react";
import { withApollo } from "react-apollo";

import Select from 'react-select';
import ChartistGraph from "react-chartist";
import Chartist from "chartist";
import chartsStyle from "assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx";
import withStyles from "material-ui/styles/withStyles";
import Table from "components/Table/Table";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import ChartCard from "components/Cards/ChartCard.jsx";
import IconCard from "components/Cards/IconCard.jsx";

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import CustomStatsCard from "components/Cards/CustomStatsCard.jsx";
import StatsCard from "components/Cards/StatsCard.jsx";
import CustomHeaderCard from "components/Cards/CustomHeaderCard.jsx";
import Button from "components/CustomButtons/Button.jsx";

import PhoneTalk from "@material-ui/icons/PhoneInTalk";
import PhoneMsg from "@material-ui/icons/PermPhoneMsg";
import AccessTime from "@material-ui/icons/AccessTime";
import InfoOutline from "@material-ui/icons/InfoOutline";

import { getPinStatsQuery, getPinSubscriptions } from "../graph";
import { styles } from 'views/stats/style';
import Loading from "../../etc/Loading";
import ExportUsersModal from "../../users/components/ExportUsersModal";
import {client, subClient} from "client";
import { downloadFile } from "lib/utils" ;

class PinStats extends React.Component{
    
    constructor(props) {
        super(props);
        var delays = 80,
            durations = 500;
        var delays2 = 80,
            durations2 = 500;

        this.state = {
            totalPinsCompleted: 0,
            totalCallSuccess: 0,
            totalCallSuccessRate: "0%",
            totalCallAttempts: 0,
            selectedProject: -1,
            pinData: {},
            selectedDate: 0,
            exportModalIsOpen: false,
            exportModalType: 0
        }

        this.pieChartData = {
          data: {
            labels: ["62%", "32%", "6%"],
            series: [62, 32, 6]
          },
          options: {
            height: "230px"
          }
        };
        this.renderCount = 0;

        this.isLoadingPin = true;
        this.triggerPinSubStarted = false;
        this.pinSub = null;

        this.dateOptions = [
          {
            value: 0,
            label: 'Last 24 hours'
          },
          {
            value: 1,
            label: 'Last 7 days'
          },
          {
            value: 2,
            label: 'Last Week'
          },
          {
            value: 3,
            label: 'Last Month'
          },
          {
            value: 4,
            label: 'Last Year'
          },
        ];
    }

    componentDidMount() {
      this.getPinStats(-1, 0);
    }

    getPinStats(pid, dateFilter) {
      this.isLoadingPin = true;

      this.props.getPinStatsQuery({
        variables: {
          pid: pid,
          dateFilter: dateFilter
        }
      }).then((data) => {
        const items = JSON.parse(data.data.pinStats.jsonObject);
        const successRate = items.success_rate * 100;
        let pinData = {
          totalPinsCompleted: items.total_pins_completed,
          totalCallAttempts: items.total_call_attempts,
          totalCallSuccess: items.total_call_success,
          totalMinutesRecorded: items.total_minutes_recorded,
          totalCallSuccessRate: Math.round(successRate) / 100,
          durationHeaders: items.duration_headers,
          durations: JSON.parse(items.durations),
          completedHeaders :items.completed_headers,
          completed: JSON.parse(items.completed)
        };

        this.isLoadingPin = false;
        console.log(items);
        this.setState({
          pinData: pinData
        });
      }).catch((error) => {
        this.isLoadingPin = false;
      });
    }

    projectOnChange(event) {
      this.setState({
        selectedProject: event.value
      });

      this.getPinStats(event.value, this.state.selectedDate);
    }

    dateChange(event) {
      this.setState({
        selectedDate: event.value
      });

      this.getPinStats(this.state.selectedProject, event.value);
    }

    startPinStatsSubscription() {
      this.triggerPinSubStarted = false;
      this.pinSub = client.subscribe({
          query: getPinSubscriptions,
          variables: {
            pid: this.state.selectedProject,
            date: this.state.selectedDate
          }
        }).subscribe(
          response => {
            //console.log('received: startPinStatsSubscription');
            const items = JSON.parse(response.data.pinStatsSub.jsonObject);
            const successRate = items.success_rate * 100;
            let pinData = {
              totalPinsCompleted: items.total_pins_completed,
              totalCallAttempts: items.total_call_attempts,
              totalCallSuccess: items.total_call_success,
              totalCallSuccessRate: Math.round(successRate) / 100,
              
            };
            //console.log(pinData);
            this.isLoadingPin = false;
            this.triggerPinSubStarted = true;
            this.setState({
              pinData: pinData
            });
          },
          error => {
            this.triggerPinSubStarted = true;
          }
      );
    }

    stopPinSub() {
      if (this.pinSub) {
        this.pinSub.unsubscribe();
        this.triggerPinSubStarted = false;
      }
    }

    onViewPasswordClose() {
        this.setState({
            showPasswordModalIsOpen: false
        });
    }

    onTMExportClick() {
        this.setState({
          exportModalIsOpen: true,
          exportModalType: 0
        });
    }

    onTCCExportClick() {
        this.setState({
          exportModalIsOpen: true,
          exportModalType: 1
        });
    }

    onExportModalCancel() {
        this.setState({exportModalIsOpen: false});
    }

    onTMExportConfirm(evt) {
      const pid = this.state.selectedProject;
      const date = this.state.selectedDate;
      let url = `${process.env.REACT_APP_SERVER_URL}export_analytics/?pid=${pid}&date_filter=${date}`;

      downloadFile(url, "tp-total-minutes-collected.csv");
      this.setState({exportModalIsOpen: false});
    }

    onTCCExportConfirm(evt) {
      const pid = this.state.selectedProject;
      const date = this.state.selectedDate;
      let url = `${process.env.REACT_APP_SERVER_URL}export_analytics/?pid=${pid}&date_filter=${date}&export_type=1`;

      downloadFile(url, "tp-total-calls-completed.csv");
      this.setState({exportModalIsOpen: false});
    }

    render() {
        this.renderCount = this.renderCount + 1;

        // const { triggerPinSub } = this.props;

        // if (triggerPinSub && !this.triggerPinSubStarted) {
        //   this.startPinStatsSubscription();
        // }
        // else if(!triggerPinSub) {
        //   this.stopPinSub();
        // }

        const {selectedProject, selectedDate, pinData, exportModalIsOpen, exportModalType} = this.state;

        const { classes } = this.props;
        const { totalPinsCompleted, totalCallSuccess, totalCallSuccessRate, 
              totalCallAttempts, items, totalMinutesRecorded, durationHeaders, 
              completedHeaders, completed, durations } = pinData;

        let showExportModal = null;    

        if (exportModalIsOpen) {
          if (exportModalType == 0)
            showExportModal = (
                  <ExportUsersModal
                      onDownloadButtonConfirm={this.onTMExportConfirm.bind(this)}
                      onDownloadButtonCancel={this.onExportModalCancel.bind(this)}
                      title="Export Total Minutes Collected?" />
              );
          else
              showExportModal = (
                  <ExportUsersModal
                      onDownloadButtonConfirm={this.onTCCExportConfirm.bind(this)}
                      onDownloadButtonCancel={this.onExportModalCancel.bind(this)}
                      title="Export Total Calls Completed?" />
              );
        }
        
        let pieData = {};
        let projectsOrder = [];

        let body = null;

        if (this.isLoadingPin)
          body = ( <Loading /> );
        else {
          body = (
              <div>
                  <GridContainer>
                    <ItemGrid xs={12} sm={12} md={3}>
                      <br />
                      <br />
                      <CustomStatsCard
                          icon={PhoneTalk}
                          iconColor="purple"
                          title="Calls done"
                          small={totalCallAttempts}
                          statText=""
                        />
                    </ItemGrid>

                    <ItemGrid xs={12} sm={12} md={3}>
                      <br />
                      <br />
                      <CustomStatsCard
                        icon={AccessTime}
                        iconColor="red"
                        title="Minutes recorded"
                        small={(totalMinutesRecorded/60).toFixed(2)}
                      />
                    </ItemGrid>
                    <ItemGrid xs={12} sm={12} md={3}>
                      <br />
                      <br />
                      <CustomStatsCard
                        icon={PhoneMsg}
                        iconColor="green"
                        title="Pins Completed"
                        small={totalPinsCompleted}
                        statText=""
                      />

                    </ItemGrid>
                    <ItemGrid xs={12} sm={12} md={3}>
                      <br />
                      <br />
                      <CustomStatsCard
                        icon={PhoneMsg}
                        iconColor="orange"
                        title="Success Rate"
                        small={totalCallSuccessRate + "%"}
                      />
                    </ItemGrid>
                </GridContainer>

                <GridContainer>
                  <ItemGrid xs={12} sm={12} md={12}>
                    <br />
                    <br />
                        <IconCard
                          icon={InfoOutline}
                          title="Total minutes collected"
                          iconColor="green"
                          content={
                                <GridContainer>
                                  <ItemGrid xs={6} sm={12} md={12}>
                                    <Button color="primary" 
                                            style={{'float': 'right'}} 
                                            type="btn"
                                            onClick={this.onTMExportClick.bind(this)}>Export</Button>
                                  </ItemGrid>
                                  <ItemGrid xs={6} sm={12} md={12}>
                                    <Table
                                      tableHead={durationHeaders}
                                      tableData={durations}
                                    />
                                  </ItemGrid>
                                </GridContainer>
                          }
                        />
                  </ItemGrid>
                </GridContainer>

                <GridContainer>
                  <ItemGrid xs={12} sm={12} md={12}>
                    <br />
                    <br />
                        <IconCard
                          icon={InfoOutline}
                          title="Total calls completed"
                          iconColor="blue"
                          content={
                                <GridContainer>
                                  <ItemGrid xs={6} sm={12} md={12}>
                                    <Button color="primary" 
                                            style={{'float': 'right'}} 
                                            type="btn"
                                            onClick={this.onTCCExportClick.bind(this)}>Export</Button>
                                  </ItemGrid>
                                  <ItemGrid xs={6} sm={12} md={12}>
                                    <Table
                                      tableHead={completedHeaders}
                                      tableData={completed}
                                    />
                                  </ItemGrid>
                                </GridContainer>
                          }
                        />
                  </ItemGrid>
                </GridContainer>
            </div>
          );
        } 

        return(
            <div>
              {showExportModal}
              <GridContainer>
                  <ItemGrid xs={6} md={4}>
                    <ItemGrid xs={2}>
                      <p>Project:</p>
                    </ItemGrid>
                    <ItemGrid xs={10}>
                      <Select
                        options={this.props.projects}
                        clearable={false}
                        value={selectedProject}
                        placeholder="Select project..."
                        onChange={this.projectOnChange.bind(this)}
                      />
                    </ItemGrid>
                  </ItemGrid>
                  <ItemGrid xs={6} md={3}>
                    <ItemGrid xs={2}>
                      <p>Date:</p>
                    </ItemGrid>
                    <ItemGrid xs={10}>
                      <Select
                        options={this.dateOptions}
                        clearable={false}
                        value={selectedDate}
                        placeholder="Select date..."
                        onChange={this.dateChange.bind(this)}
                      />
                    </ItemGrid>
                  </ItemGrid>
              </GridContainer> 
              <hr />
              {body}
            </div>
        )
        
    }
}

export default (getPinStatsQuery)(withApollo(PinStats));



// WEBPACK FOOTER //
// ./src/views/stats/components/PinStats.js